import { animateAttribute, onDelegatedClick, setCss, swalAlert, viewTransition } from '../functions.js';

export default class PacklistDesktopElement extends HTMLElement {

    connectedCallback() {

        onDelegatedClick(this, '.packlist__summary', (event) => {

            let otherDetails = this.querySelectorAll('.packlist__detail');

            let image = this.querySelector('.infocard2__image');
            let detail = event.target.closest('.packlist__detail');

            if (detail.classList.contains('open')) {
                detail.classList.remove('open');
            } else {
                detail.classList.add('open');

                image.src = detail.dataset.imageSrc;
            }

            otherDetails.forEach((otherDetail) => {
                if (otherDetail === detail) {
                    return;
                }
                otherDetail.classList.remove('open');
            });
            
        });


        this.querySelector('.packlist__summary').click();
    }
};

window.customElements.define('packlist-desktop', PacklistDesktopElement);

